/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/main/LICENSE.md for details.
 * v1.9.2
 */
import { L as Label, d as defineCustomElement$1 } from './label.js';

const CalciteLabel = Label;
const defineCustomElement = defineCustomElement$1;

export { CalciteLabel, defineCustomElement };
